import React from 'react'
import DashboardScheduleMethods, { DashboardScheduleStat } from './dashboard__schedule.local.methods'
import Card from 'blocks.simple/card/card'
import Animation from 'blocks.simple/animation/animation'
import Link from 'blocks.simple/link/link'
import translate from 'core/translate'
import styles from './dashboard__schedule.jcss'
import { routes } from 'features/routes'
import helpers from 'core/helpers'
import { Typography } from 'atoms/Typography'
import { getURLSearchParamsString } from 'features/routes/utils'
import { cn } from 'ethcss'

interface IDashboardScheduleProps {
    className?: string
    rules?: {
        order: number
    }
}

const displaysQueryParam = helpers.prefixQuery({ name: 'displays', field: 'filterList' })

const linkRoutes = {
    digitalSignageWithoutSchedule: {
        pathname: `/${routes.displays.path}`,
        search: getURLSearchParamsString({
            [displaysQueryParam]: JSON.stringify([
                {
                    name: 'hasActualSchedule',
                    type: 'select',
                    options: [
                        {
                            value: false,
                            label: 'withoutActualSchedule',
                            selected: true,
                        },
                    ],
                },
                {
                    name: 'type',
                    type: 'select',
                    options: [
                        {
                            value: 'digitalSignage',
                            label: 'digitalSignage',
                            selected: true,
                        },
                    ],
                },
            ]),
        }),
    },
}

const DashboardSchedule = (p_: IDashboardScheduleProps) => {
    const { s_ } = DashboardScheduleMethods()
    const itemOrder = p_.rules?.order ?? 0

    const getTitle = () => translate('scheduleSummary')

    function renderScheduleStatsLinks({ key, value }: DashboardScheduleStat) {
        if (key === 'digitalSignageWithoutSchedule') {
            return (
                <Link className={styles.link} to={linkRoutes.digitalSignageWithoutSchedule}>
                    {value}
                </Link>
            )
        }

        return value
    }

    return (
        <Animation className={cn(p_.className)} style={{ order: itemOrder }}>
            {!s_.data ? null : (
                <Card
                    title={getTitle()}
                    titleClassName={styles.title}
                    icon={{
                        type: 'date',
                        size: 20,
                        default: true,
                    }}
                >
                    <div className={styles.wrapper}>
                        {s_.data.map((item, index) => (
                            <div key={index} className={styles.content}>
                                <Typography type="text" className={styles.text}>
                                    {translate(item.label)}
                                </Typography>
                                <div className={styles.info}>{renderScheduleStatsLinks(item)}</div>
                            </div>
                        ))}
                    </div>
                    <Typography type="text" className={styles.footer}>
                        {translate('schedulesInCompany')}: {s_.schedulesCount}
                    </Typography>
                </Card>
            )}
        </Animation>
    )
}

export default DashboardSchedule
